<i18n src="@/locales/views/service_provider/services/container_op/show_schedule.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/container_service.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/container_scheduled_service.yml" lang="yaml"></i18n>
<template>
  <div class="panel sm:col-span-3 flex flex-col justify-between">
    <div class="panel-header">
      <div class="flex justify-between">
        <h3 class="panel-header-title">
          {{ service_template.name }}
        </h3>
        <div class="md:flex gap-x-2">
          <div v-if="container_service.finished">
            <span
              class="inline-flex items-center px-2 py-0.5 rounded text-sm font-medium bg-slate-100 text-slate-800"
            >
              <i class="fa-solid fa-check"></i>
              <span class="space-icon"></span>
              {{ $t("model.container_service.finished") }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="panel-body h-full">
      <div class="space-y-8 divide-y divide-slate-200">
        <div class="text-sm space-y-6 divide-y divide-white">
          <div
            v-if="container_service.container_schedule_technician"
            class="flex"
          >
            <i class="fa-regular fa-user-helmet-safety pt-1"></i>
            <span class="space-icon"></span>
            {{
              $t("model.container_service.container_schedule_technician_id")
            }}:
            <span class="space-icon"></span>
            <p>
              {{ container_service.container_schedule_technician.user.name }}
            </p>
          </div>
          <div
            class="grid grid-cols-12 gap-y-6 gap-x-4 justify-items-stretch"
            v-if="service_template.service_template_tasks.length > 0"
          >
            <div
              class="col-span-6 md:col-span-4 lg:col-span-3"
              v-for="task in service_template.service_template_tasks"
              :key="task.id"
            >
              <i
                v-if="containerTask(task)?.completed"
                class="fa-light fa-square-check text-[#5c7a2e]"
              ></i>
              <i v-else class="fa-light fa-square"></i>
              <span class="space-icon"></span>
              {{ task.name }}
            </div>
          </div>
          <div
            class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-12 justify-items-stretch"
            v-if="service_template.service_template_inputs.length > 0"
          >
            <div
              class="sm:col-span-6 md:col-span-4 lg:col-span-3"
              v-for="input in service_template.service_template_inputs"
              :key="input.id"
            >
              {{ input.name }}:
              <u>{{ containerInput(input)?.value }}</u>
            </div>
          </div>
          <div
            class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-12 justify-items-stretch"
            v-if="service_template.service_template_measures.length > 0"
          >
            <div
              class="sm:col-span-6 md:col-span-4 lg:col-span-3"
              v-for="measure in service_template.service_template_measures"
              :key="measure.id"
            >
              {{ measure.name }}:
              {{ containerMeasure(measure)?.value }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="panel-footer">
      <div class="panel-footer-actions">
        <template v-if="has_files">
          <white-button
            @click.prevent="goToServiceAttachments()"
            :label="$t('labels.attchments_button')"
            icon="fa-solid fa-file"
          />
          <span class="space-icon"></span>
        </template>
        <edit-button
          @click.prevent="goToEditService()"
          :label="$t('labels.edit_service_button')"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    service_template: {
      type: Object,
      required: true,
    },
    container_service: {
      type: Object,
      default: () => {
        return {};
      },
    },
    rounded_class: {
      type: String,
      default: "",
    },
  },
  computed: {
    current_route_params: function () {
      return this.$router.currentRoute._value.params;
    },
    has_files: function () {
      let files = this.service_template?.service_template_files ?? [];
      return files.length > 0;
    },
  },
  methods: {
    containerAttachment: function (service_template_file) {
      if (
        !service_template_file ||
        !this.container_service.container_service_attachments
      )
        return;

      let container_service_attachment =
        this.container_service.container_service_attachments.find(
          (container_service_attachment) =>
            container_service_attachment.service_template_file_id ==
            service_template_file.id
        );
      return container_service_attachment;
    },
    containerInput: function (service_template_input) {
      if (
        !service_template_input ||
        !this.container_service.container_service_inputs
      )
        return;

      let container_service_input =
        this.container_service.container_service_inputs.find(
          (container_service_input) =>
            container_service_input.service_template_input_id ==
            service_template_input.id
        );
      return container_service_input;
    },
    containerMeasure: function (service_template_measure) {
      if (
        !service_template_measure ||
        !this.container_service.container_service_measures
      )
        return;

      let container_service_measure =
        this.container_service.container_service_measures.find(
          (container_service_measure) =>
            container_service_measure.service_template_measure_id ==
            service_template_measure.id
        );
      return container_service_measure;
    },
    containerTask: function (service_template_task) {
      if (
        !service_template_task ||
        !this.container_service.container_service_tasks
      )
        return;

      let container_service_task =
        this.container_service.container_service_tasks.find(
          (container_service_task) =>
            container_service_task.service_template_task_id ==
            service_template_task.id
        );
      return container_service_task;
    },
    goToEditService: function () {
      this.$router.push({
        name: "sp_services_container_op_edit_service_path",
        params: {
          agro_exporter_id: this.current_route_params.agro_exporter_id,
          container_scheduled_service_id:
            this.current_route_params.container_scheduled_service_id,
          container_service_id: this.container_service?.id,
          service_provider_id: this.current_route_params.service_provider_id,
        },
      });
    },
    goToServiceAttachments: function () {
      this.$router.push({
        name: "sp_services_container_op_show_attachments_path",
        params: {
          agro_exporter_id: this.current_route_params.agro_exporter_id,
          container_scheduled_service_id:
            this.current_route_params.container_scheduled_service_id,
          container_service_id: this.container_service?.id,
          service_provider_id: this.current_route_params.service_provider_id,
        },
      });
    },
  },
};
</script>
